module.exports = __webpack_public_path__ + "static/img/case_detail_05_2.385d073.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_05_2.png
// module id = m/aL
// module chunks = 34